var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _g2, _path12, _g3, _path13, _g4, _path14, _g5, _path15, _g6, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g7, _path24, _g8, _path25, _path26, _path27, _path28, _path29, _path30, _g9, _path31, _g10, _path32, _path33, _path34, _path35, _g11, _path36, _g12, _path37, _g13, _path38, _g14, _path39, _g15, _path40, _g16, _path41, _g17, _path42, _path43, _path44, _path45, _g18, _path46, _path47, _path48, _g19, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 307,
    viewBox: "0 0 359 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.915 17.8105C221.054 47.3853 275.065 20.923 325.933 67.4961C382.693 119.465 371.563 250.043 250.605 265.44C101.852 284.372 23.4419 209.487 4.57658 134.601C-16.9731 49.0595 39.1709 -36.4817 156.915 17.8105Z",
    fill: "#D9EFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.121 36.5594C115.889 36.5594 118.133 34.365 118.133 31.6579C118.133 28.9512 115.889 26.7569 113.121 26.7569C112.52 26.7569 111.945 26.866 111.411 27.0558C110.54 23.804 107.515 21.4043 103.916 21.4043C100.435 21.4043 97.4902 23.6501 96.513 26.7407C95.7042 26.2688 94.7619 25.9923 93.7515 25.9923C90.7683 25.9923 88.3496 28.3578 88.3496 31.2758C88.3496 34.1939 90.7683 36.5594 93.7515 36.5594H113.121Z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.206 97.4043L151.882 97.5336C151.379 97.5723 151.008 98.1152 151.056 98.7421L154.538 114.631C154.58 115.203 154.968 115.646 155.419 115.685L163.623 115.439C164.124 115.394 164.498 114.851 164.45 114.231L161.09 98.461C161.042 97.8858 160.661 97.4431 160.206 97.4043Z",
    fill: "#D3D7E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.027 97.5004L161.157 97.3711C161.609 97.4099 161.993 97.8526 162.041 98.4246L163.778 105.838L164.856 110.791L164.923 111.121L165.569 114.091C165.617 114.711 165.246 115.257 164.746 115.296L156.539 115.545C156.087 115.503 155.703 115.064 155.658 114.488L155.529 113.913L152.201 98.7089C152.149 98.0853 152.521 97.5424 153.027 97.5004Z",
    fill: "#F4F6F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.047 98.5474L160.321 98.4473C160.673 98.4763 160.97 98.8157 160.999 99.2616L162.342 104.978L163.174 108.804L163.229 109.053L163.723 111.344C163.762 111.826 163.478 112.243 163.09 112.275L156.762 112.469C156.413 112.436 156.113 112.094 156.081 111.654L155.98 111.208L153.408 99.4781C153.373 98.9966 153.657 98.5798 154.047 98.5474Z",
    fill: "#D3D7E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.529 113.913L155.658 114.488C155.703 115.063 156.087 115.502 156.539 115.545L164.747 115.296C165.247 115.257 165.618 114.711 165.57 114.09L164.924 111.121L164.856 110.791C163.52 109.295 159.25 106.635 160.893 104.418C160.932 104.36 161.826 104.69 163.778 105.837C166.147 107.22 168.765 108.888 168.878 109.524C169.084 110.675 167.474 113.043 167.738 114.604L169.42 118.479L162.171 122.567L158.702 117.435C158.702 117.435 154.835 116.307 154.261 114.294L155.529 113.913Z",
    fill: "#EB9C6E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.712 109.703C167.803 110.059 165.092 114.745 168.242 115.753L169.242 117.566L162.081 122.287L158.702 117.436C158.702 117.436 154.835 116.309 154.261 114.292L155.529 113.914L155.658 114.489C155.703 115.064 156.087 115.504 156.539 115.546L164.747 115.297C165.247 115.258 165.618 114.712 165.57 114.092L164.924 111.122L164.856 110.792C163.52 109.296 159.25 106.637 160.893 104.42C160.893 104.42 167.625 109.351 167.712 109.703Z",
    fill: "#F4907D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.538 103.101C152.634 102.984 158.173 103.404 158.608 104.577C159.044 105.754 161.113 111.04 160.077 112.983C159.047 114.925 154.968 115.594 154.968 115.594C154.968 115.594 147.396 109.205 152.538 103.101Z",
    fill: "#F4AF9F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.54 104.449L158.608 104.578C159.043 105.755 161.112 111.041 160.076 112.984C159.047 114.926 154.967 115.595 154.967 115.595C154.967 115.595 152.789 113.753 151.565 111.109C158.356 113.743 158.591 106.42 158.54 104.449Z",
    fill: "#F4907D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 117,
    width: 5,
    height: 6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.941 122.228L158.701 117.436L162.009 122.179L161.941 122.228Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.896 122.228H162.083V117.436H161.896V122.228Z",
    fill: "#EEAE82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.616 122.228H161.893V117.436H161.616V122.228Z",
    fill: "#EEAF83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.525 122.228H161.618V117.436H161.525V122.228Z",
    fill: "#EEB084"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.337 122.228H161.525V117.436H161.337V122.228Z",
    fill: "#EEB184"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.061 122.228H161.338V117.436H161.061V122.228Z",
    fill: "#EFB185"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.78 122.228H161.057V117.436H160.78V122.228Z",
    fill: "#EFB286"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.502 122.228H160.78V117.436H160.502V122.228Z",
    fill: "#EFB386"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.225 122.228H160.502V117.436H160.225V122.228Z",
    fill: "#EFB387"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.85 122.228H160.221V117.436H159.85V122.228Z",
    fill: "#EFB488"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.479 122.228H159.85V117.436H159.479V122.228Z",
    fill: "#F0B589"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.201 122.228H159.479V117.436H159.201V122.228Z",
    fill: "#F0B68A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.924 122.228H159.202V117.436H158.924V122.228Z",
    fill: "#F0B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.643 122.228H158.92V117.436H158.643V122.228Z",
    fill: "#F0B78B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 115,
    width: 4,
    height: 3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.679 117.429C158.45 117.358 156.365 116.708 155.119 115.564C156.365 116.708 158.45 117.358 158.679 117.429Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.643 117.429H158.737V115.564H158.643V117.429Z",
    fill: "#F0B78B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.46 117.429H158.647V115.564H158.46V117.429Z",
    fill: "#F0B88C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.366 117.429H158.459V115.564H158.366V117.429Z",
    fill: "#F0B88D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.088 117.429H158.366V115.564H158.088V117.429Z",
    fill: "#F0B98D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.808 117.429H158.085V115.564H157.808V117.429Z",
    fill: "#F0B98E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.624 117.429H157.811V115.564H157.624V117.429Z",
    fill: "#F0BA8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.436 117.429H157.623V115.564H157.436V117.429Z",
    fill: "#F0BB8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.159 117.429H157.436V115.564H157.159V117.429Z",
    fill: "#F0BB90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.878 117.429H157.156V115.564H156.878V117.429Z",
    fill: "#F1BB90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.788 117.429H156.881V115.564H156.788V117.429Z",
    fill: "#F1BC91"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.6 117.429H156.787V115.564H156.6V117.429Z",
    fill: "#F1BD92"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.323 117.429H156.6V115.564H156.323V117.429Z",
    fill: "#F1BD93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.042 117.429H156.32V115.564H156.042V117.429Z",
    fill: "#F1BE93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.671 117.429H156.042V115.564H155.671V117.429Z",
    fill: "#F1BF94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.394 117.429H155.671V115.564H155.394V117.429Z",
    fill: "#F2C095"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.116 117.429H155.393V115.564H155.116V117.429Z",
    fill: "#F2C196"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 160,
    y: 104,
    width: 9,
    height: 12
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.235 115.751C167.076 115.38 166.715 114.504 166.712 113.535C166.712 111.916 167.718 110.022 167.715 109.725C167.715 109.715 167.715 109.709 167.712 109.702C167.625 109.35 160.893 104.419 160.893 104.419C160.896 104.412 160.902 104.412 160.915 104.412C161.064 104.412 161.964 104.771 163.778 105.837C166.147 107.22 168.764 108.888 168.877 109.524C168.89 109.595 168.896 109.673 168.896 109.754C168.89 110.865 167.715 112.785 167.709 114.223C167.709 114.355 167.718 114.481 167.738 114.604L168.235 115.751Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.771 115.751H168.958V104.412H168.771V115.751Z",
    fill: "#EB9D6F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.49 115.751H168.767V104.412H168.49V115.751Z",
    fill: "#EB9E6F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.119 115.751H168.49V104.412H168.119V115.751Z",
    fill: "#EB9F70"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.841 115.751H168.119V104.412H167.841V115.751Z",
    fill: "#EB9F71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.56 115.751H167.837V104.412H167.56V115.751Z",
    fill: "#EBA072"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.005 115.751H167.564V104.412H167.005V115.751Z",
    fill: "#EBA173"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.725 115.751H167.002V104.412H166.725V115.751Z",
    fill: "#EBA274"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.541 115.751H166.728V104.412H166.541V115.751Z",
    fill: "#ECA375"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.076 115.751H166.54V104.412H166.076V115.751Z",
    fill: "#ECA476"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.795 115.751H166.073V104.412H165.795V115.751Z",
    fill: "#ECA477"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.705 115.751H165.798V104.412H165.705V115.751Z",
    fill: "#ECA578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.517 115.751H165.704V104.412H165.517V115.751Z",
    fill: "#ECA678"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.96 115.751H165.518V104.412H164.96V115.751Z",
    fill: "#EDA779"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.775 115.751H164.962V104.412H164.775V115.751Z",
    fill: "#EDA87A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.587 115.751H164.775V104.412H164.587V115.751Z",
    fill: "#EDA87B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.311 115.751H164.588V104.412H164.311V115.751Z",
    fill: "#EDA97B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.124 115.751H164.311V104.412H164.124V115.751Z",
    fill: "#EDA97C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.033 115.751H164.126V104.412H164.033V115.751Z",
    fill: "#EDA97D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.662 115.751H164.033V104.412H163.662V115.751Z",
    fill: "#EEAA7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.381 115.751H163.659V104.412H163.381V115.751Z",
    fill: "#EEAB7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.104 115.751H163.381V104.412H163.104V115.751Z",
    fill: "#EEAC7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.823 115.751H163.1V104.412H162.823V115.751Z",
    fill: "#EEAC80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.545 115.751H162.823V104.412H162.545V115.751Z",
    fill: "#EEAD80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.268 115.751H162.545V104.412H162.268V115.751Z",
    fill: "#EEAE81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.896 115.751H162.267V104.412H161.896V115.751Z",
    fill: "#EEAE82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.616 115.751H161.893V104.412H161.616V115.751Z",
    fill: "#EEAF83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.525 115.751H161.618V104.412H161.525V115.751Z",
    fill: "#EEB084"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.337 115.751H161.525V104.412H161.337V115.751Z",
    fill: "#EEB184"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.061 115.751H161.338V104.412H161.061V115.751Z",
    fill: "#EFB185"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.874 115.751H161.061V104.412H160.874V115.751Z",
    fill: "#EFB286"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 104,
    width: 15,
    height: 19
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.01 122.18L158.702 117.436C158.702 117.436 156.439 116.777 155.119 115.565C155.306 115.53 155.648 115.459 156.074 115.346C156.21 115.459 156.368 115.53 156.539 115.546L164.746 115.297C165.218 115.262 165.576 114.77 165.576 114.192C165.576 114.16 165.573 114.124 165.569 114.092L164.924 111.122L164.856 110.792C164.491 110.385 163.911 109.894 163.291 109.345C161.993 108.201 160.528 106.818 160.522 105.499C160.522 105.131 160.635 104.769 160.893 104.42C160.893 104.42 167.625 109.351 167.712 109.703C167.716 109.71 167.716 109.716 167.716 109.726C167.719 110.023 166.712 111.917 166.712 113.536C166.715 114.505 167.077 115.381 168.235 115.753C168.238 115.753 168.238 115.753 168.242 115.753L169.123 117.349L162.01 122.18Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.048 122.18H169.142V104.42H169.048V122.18Z",
    fill: "#F4907D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.861 122.18H169.048V104.42H168.861V122.18Z",
    fill: "#F4917E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.771 122.18H168.865V104.42H168.771V122.18Z",
    fill: "#F4927E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.491 122.18H168.768V104.42H168.491V122.18Z",
    fill: "#F4927F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.12 122.18H168.491V104.42H168.12V122.18Z",
    fill: "#F49380"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.841 122.18H168.119V104.42H167.841V122.18Z",
    fill: "#F49481"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.561 122.18H167.838V104.42H167.561V122.18Z",
    fill: "#F49582"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.284 122.18H167.561V104.42H167.284V122.18Z",
    fill: "#F49683"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.005 122.18H167.283V104.42H167.005V122.18Z",
    fill: "#F49784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.725 122.18H167.002V104.42H166.725V122.18Z",
    fill: "#F49785"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.448 122.18H166.725V104.42H166.448V122.18Z",
    fill: "#F49886"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.077 122.18H166.448V104.42H166.077V122.18Z",
    fill: "#F49987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.795 122.18H166.073V104.42H165.795V122.18Z",
    fill: "#F49A88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.518 122.18H165.795V104.42H165.518V122.18Z",
    fill: "#F49B89"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.241 122.18H165.518V104.42H165.241V122.18Z",
    fill: "#F49B8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.959 122.18H165.237V104.42H164.959V122.18Z",
    fill: "#F49C8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.776 122.18H164.963V104.42H164.776V122.18Z",
    fill: "#F49D8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.588 122.18H164.776V104.42H164.588V122.18Z",
    fill: "#F49D8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.311 122.18H164.588V104.42H164.311V122.18Z",
    fill: "#F59E8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.124 122.18H164.311V104.42H164.124V122.18Z",
    fill: "#F59F8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.662 122.18H164.126V104.42H163.662V122.18Z",
    fill: "#F5A08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.381 122.18H163.659V104.42H163.381V122.18Z",
    fill: "#F5A08F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.288 122.18H163.381V104.42H163.288V122.18Z",
    fill: "#F5A190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.104 122.18H163.291V104.42H163.104V122.18Z",
    fill: "#F5A290"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.823 122.18H163.1V104.42H162.823V122.18Z",
    fill: "#F5A291"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.545 122.18H162.823V104.42H162.545V122.18Z",
    fill: "#F5A392"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.361 122.18H162.548V104.42H162.361V122.18Z",
    fill: "#F5A493"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.268 122.18H162.362V104.42H162.268V122.18Z",
    fill: "#F5A593"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.897 122.18H162.268V104.42H161.897V122.18Z",
    fill: "#F5A594"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.616 122.18H161.893V104.42H161.616V122.18Z",
    fill: "#F6A595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.526 122.18H161.619V104.42H161.526V122.18Z",
    fill: "#F6A696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.338 122.18H161.526V104.42H161.338V122.18Z",
    fill: "#F6A796"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.061 122.18H161.338V104.42H161.061V122.18Z",
    fill: "#F6A897"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.78 122.18H161.057V104.42H160.78V122.18Z",
    fill: "#F6A998"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.502 122.18H160.78V104.42H160.502V122.18Z",
    fill: "#F6AA99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.225 122.18H160.502V104.42H160.225V122.18Z",
    fill: "#F6AA9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.851 122.18H160.222V104.42H159.851V122.18Z",
    fill: "#F6AB9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.479 122.18H159.85V104.42H159.479V122.18Z",
    fill: "#F6AC9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.201 122.18H159.479V104.42H159.201V122.18Z",
    fill: "#F7AD9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.108 122.18H159.202V104.42H159.108V122.18Z",
    fill: "#F7AE9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.924 122.18H159.112V104.42H158.924V122.18Z",
    fill: "#F7AE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.644 122.18H158.921V104.42H158.644V122.18Z",
    fill: "#F7AF9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.366 122.18H158.643V104.42H158.366V122.18Z",
    fill: "#F7AFA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.088 122.18H158.366V104.42H158.088V122.18Z",
    fill: "#F7B0A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.808 122.18H158.085V104.42H157.808V122.18Z",
    fill: "#F7B1A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.436 122.18H157.807V104.42H157.436V122.18Z",
    fill: "#F7B2A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.159 122.18H157.436V104.42H157.159V122.18Z",
    fill: "#F7B3A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.878 122.18H157.156V104.42H156.878V122.18Z",
    fill: "#F7B4A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.788 122.18H156.881V104.42H156.788V122.18Z",
    fill: "#F7B5A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.6 122.18H156.787V104.42H156.6V122.18Z",
    fill: "#F7B5A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.323 122.18H156.6V104.42H156.323V122.18Z",
    fill: "#F7B5A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.042 122.18H156.32V104.42H156.042V122.18Z",
    fill: "#F7B6A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.858 122.18H156.045V104.42H155.858V122.18Z",
    fill: "#F7B7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.671 122.18H155.859V104.42H155.671V122.18Z",
    fill: "#F7B7A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.394 122.18H155.671V104.42H155.394V122.18Z",
    fill: "#F7B8A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.207 122.18H155.394V104.42H155.207V122.18Z",
    fill: "#F7B9AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.116 122.18H155.209V104.42H155.116V122.18Z",
    fill: "#F7B9AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 103,
    width: 9,
    height: 13
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.967 115.593C154.967 115.593 150.752 112.035 150.749 107.695C150.746 106.219 151.233 104.651 152.537 103.1C152.547 103.09 152.621 103.084 152.74 103.084C153.754 103.084 158.22 103.53 158.608 104.577L158.54 104.448C158.543 104.561 158.543 104.69 158.543 104.832C158.546 106.836 158.14 111.673 154.193 111.673C153.447 111.673 152.579 111.502 151.566 111.108C152.789 113.751 154.967 115.593 154.967 115.593Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.366 115.593H158.643V103.084H158.366V115.593Z",
    fill: "#F7C6BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.088 115.593H158.366V103.084H158.088V115.593Z",
    fill: "#F7C6BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.436 115.593H158.085V103.084H157.436V115.593Z",
    fill: "#F7C7BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.159 115.593H157.436V103.084H157.159V115.593Z",
    fill: "#F7C8BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.6 115.593H157.158V103.084H156.6V115.593Z",
    fill: "#F7C9BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.323 115.593H156.6V103.084H156.323V115.593Z",
    fill: "#F7C9BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.042 115.593H156.32V103.084H156.042V115.593Z",
    fill: "#F7CAC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.671 115.593H156.042V103.084H155.671V115.593Z",
    fill: "#F7CBC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.393 115.593H155.67V103.084H155.393V115.593Z",
    fill: "#F7CCC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.206 115.593H155.393V103.084H155.206V115.593Z",
    fill: "#F7CCC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.022 115.593H155.209V103.084H155.022V115.593Z",
    fill: "#F7CCC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.742 115.593H155.019V103.084H154.742V115.593Z",
    fill: "#F7CDC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.464 115.593H154.742V103.084H154.464V115.593Z",
    fill: "#F7CDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.906 115.593H154.464V103.084H153.906V115.593Z",
    fill: "#F8CEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.628 115.593H153.906V103.084H153.628V115.593Z",
    fill: "#F8CFC6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.256 115.593H153.627V103.084H153.256V115.593Z",
    fill: "#F8D0C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.979 115.593H153.256V103.084H152.979V115.593Z",
    fill: "#F8D1C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.699 115.593H152.976V103.084H152.699V115.593Z",
    fill: "#F8D1C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.143 115.593H152.701V103.084H152.143V115.593Z",
    fill: "#F8D2C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.956 115.593H152.143V103.084H151.956V115.593Z",
    fill: "#F9D3CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.214 115.593H151.957V103.084H151.214V115.593Z",
    fill: "#F9D4CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.121 115.593H151.214V103.084H151.121V115.593Z",
    fill: "#F9D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.933 115.593H151.12V103.084H150.933V115.593Z",
    fill: "#F9D5CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.746 115.593H150.933V103.084H150.746V115.593Z",
    fill: "#F9D6CE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 104,
    width: 10,
    height: 12
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.967 115.595C154.967 115.595 152.789 113.753 151.565 111.109C152.579 111.504 153.447 111.675 154.193 111.675C158.14 111.675 158.546 106.837 158.543 104.834C158.543 104.692 158.543 104.562 158.54 104.449L158.608 104.578C158.959 105.525 160.367 109.135 160.363 111.52C160.363 111.823 160.341 112.105 160.289 112.363C160.244 112.596 160.173 112.803 160.076 112.984C159.392 114.273 157.359 115.003 156.074 115.346C155.648 115.459 155.306 115.53 155.119 115.566C155.103 115.569 155.09 115.572 155.077 115.575C155.006 115.588 154.967 115.595 154.967 115.595Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.224 115.595H160.411V104.449H160.224V115.595Z",
    fill: "#F6AA9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.85 115.595H160.221V104.449H159.85V115.595Z",
    fill: "#F6AB9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.479 115.595H159.85V104.449H159.479V115.595Z",
    fill: "#F6AC9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.201 115.595H159.479V104.449H159.201V115.595Z",
    fill: "#F7AD9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.108 115.595H159.202V104.449H159.108V115.595Z",
    fill: "#F7AE9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.923 115.595H159.111V104.449H158.923V115.595Z",
    fill: "#F7AE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.643 115.595H158.92V104.449H158.643V115.595Z",
    fill: "#F7AF9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.366 115.595H158.643V104.449H158.366V115.595Z",
    fill: "#F7AFA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.088 115.595H158.366V104.449H158.088V115.595Z",
    fill: "#F7B0A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.807 115.595H158.085V104.449H157.807V115.595Z",
    fill: "#F7B1A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.436 115.595H157.807V104.449H157.436V115.595Z",
    fill: "#F7B2A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.159 115.595H157.436V104.449H157.159V115.595Z",
    fill: "#F7B3A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.877 115.595H157.155V104.449H156.877V115.595Z",
    fill: "#F7B4A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.788 115.595H156.881V104.449H156.788V115.595Z",
    fill: "#F7B5A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.6 115.595H156.787V104.449H156.6V115.595Z",
    fill: "#F7B5A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.323 115.595H156.6V104.449H156.323V115.595Z",
    fill: "#F7B5A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.041 115.595H156.319V104.449H156.041V115.595Z",
    fill: "#F7B6A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.858 115.595H156.045V104.449H155.858V115.595Z",
    fill: "#F7B7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.67 115.595H155.858V104.449H155.67V115.595Z",
    fill: "#F7B7A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.393 115.595H155.67V104.449H155.393V115.595Z",
    fill: "#F7B8A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.206 115.595H155.393V104.449H155.206V115.595Z",
    fill: "#F7B9AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.022 115.595H155.209V104.449H155.022V115.595Z",
    fill: "#F7B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.463 115.595H155.022V104.449H154.463V115.595Z",
    fill: "#F7BAAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.37 115.595H154.463V104.449H154.37V115.595Z",
    fill: "#F8BBAD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.186 115.595H154.373V104.449H154.186V115.595Z",
    fill: "#F8BCAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.906 115.595H154.183V104.449H153.906V115.595Z",
    fill: "#F8BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.627 115.595H153.905V104.449H153.627V115.595Z",
    fill: "#F8BDAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.441 115.595H153.628V104.449H153.441V115.595Z",
    fill: "#F8BEB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.256 115.595H153.444V104.449H153.256V115.595Z",
    fill: "#F8BEB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.979 115.595H153.256V104.449H152.979V115.595Z",
    fill: "#F8BFB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.699 115.595H152.976V104.449H152.699V115.595Z",
    fill: "#F8BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.605 115.595H152.699V104.449H152.605V115.595Z",
    fill: "#F8C0B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.42 115.595H152.608V104.449H152.42V115.595Z",
    fill: "#F8C1B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.143 115.595H152.42V104.449H152.143V115.595Z",
    fill: "#F8C2B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.863 115.595H152.14V104.449H151.863V115.595Z",
    fill: "#F9C2B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.585 115.595H151.863V104.449H151.585V115.595Z",
    fill: "#F9C3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.491 115.595H151.584V104.449H151.491V115.595Z",
    fill: "#F9C4B6"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.607 117.021C169.607 117.021 187.18 142.806 190.824 141.804C194.468 140.805 201.9 132.239 201.9 132.239L207.748 147.614C207.748 147.614 202.252 156.09 192.031 158.026C181.816 159.958 161.448 122.56 161.448 122.56L169.607 117.021Z",
    fill: "#FC686F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.435 140.384C194.561 139.566 195.771 138.509 196.917 137.43C195.771 138.513 194.561 139.569 193.435 140.384Z",
    fill: "#366DFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.05 154.848C198.153 152.547 192.934 146.471 192.637 145.075C192.476 144.342 192.889 142.38 193.434 140.383C194.56 139.569 195.771 138.512 196.916 137.43L196.92 137.427C196.923 137.423 196.926 137.42 196.929 137.417C197.584 136.796 198.217 136.173 198.798 135.578C196.916 138.926 195.713 141.734 196.042 143.03C196.661 145.463 199.376 148.94 202.477 153.135C201.741 153.716 200.935 154.298 200.05 154.848Z",
    fill: "#CE484E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.999 67.1828C195.336 66.1455 199.854 66.5462 204.379 66.9501C207.09 67.1892 209.797 67.4316 212.04 67.3637C217.805 67.1892 228.177 57.3784 238.695 68.456C246.451 76.622 239.525 88.5397 243.327 90.4883C247.135 92.4433 251.55 92.8667 255.458 94.6052C259.367 96.347 262.965 100.267 262.046 104.448C261.245 108.087 257.379 110.375 256.382 113.965C255.387 117.562 257.689 121.41 260.822 123.43C263.959 125.45 267.761 126.073 271.431 126.729C275.104 127.382 278.909 128.18 281.865 130.459C287.384 134.721 288.194 143.249 285.115 149.508C282.03 155.768 275.943 160.03 269.594 162.909C262.175 166.283 254.071 168.138 245.925 168.332C237.195 168.535 227.493 166.244 222.652 158.964C219.376 154.039 218.96 147.75 219.412 141.853C219.86 135.949 226.228 126.019 220.616 124.167C202.184 118.082 201.639 106.739 199.044 98.8352C198.005 95.6781 194.619 90.1845 192.57 87.218C190.514 84.2547 188.606 81.0232 188.238 77.4363C187.877 73.8493 189.707 68.6466 192.999 67.1828Z",
    fill: "#473F65"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.472 276.554C145.472 276.554 132.934 294.04 134.467 295.707C137.517 299.013 154.996 283.185 159.376 278.522C161.206 276.577 162.426 266.902 158.585 265.312C154.028 263.428 145.472 276.554 145.472 276.554Z",
    fill: "#27356B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.496 260.302C154.496 260.302 155.561 262.367 152.985 266.025C150.41 269.69 139.282 286.009 140.173 286.956C141.06 287.906 155.761 276.583 157.226 273.493C158.691 270.404 162.177 260.48 161.699 260.328C161.215 260.173 154.496 260.302 154.496 260.302Z",
    fill: "#F4AF9F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.226 273.493C158.691 270.404 162.177 260.48 161.699 260.328C161.215 260.173 154.496 260.302 154.496 260.302C154.496 260.302 155.296 261.86 153.818 264.668C155.47 264.384 157.901 266.064 157.901 266.064C157.901 266.064 155.677 273.309 151.175 279.569C154.128 277.103 156.661 274.686 157.226 273.493Z",
    fill: "#F4907D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 264,
    width: 18,
    height: 24
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.344 287.012C140.266 287.012 140.208 286.995 140.173 286.957C140.137 286.918 140.121 286.86 140.124 286.776C140.137 284.753 150.51 269.549 152.986 266.026C153.324 265.548 153.599 265.092 153.821 264.669C153.951 264.646 154.083 264.637 154.222 264.637C155.839 264.637 157.901 266.065 157.901 266.065C157.901 266.065 155.677 273.31 151.175 279.569C151.391 279.388 151.604 279.208 151.817 279.027C147.315 282.856 141.519 287.012 140.344 287.012Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.569 287.012H157.94V264.637H157.569V287.012Z",
    fill: "#F4B6A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.291 287.012H157.569V264.637H157.291V287.012Z",
    fill: "#F4B7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.919 287.012H157.29V264.637H156.919V287.012Z",
    fill: "#F4B7A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.548 287.012H156.919V264.637H156.548V287.012Z",
    fill: "#F4B7AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.362 287.012H156.549V264.637H156.362V287.012Z",
    fill: "#F4B8AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.177 287.012H156.365V264.637H156.177V287.012Z",
    fill: "#F4B9AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.806 287.012H156.177V264.637H155.806V287.012Z",
    fill: "#F5B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.158 287.012H155.806V264.637H155.158V287.012Z",
    fill: "#F5BAAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.787 287.012H155.158V264.637H154.787V287.012Z",
    fill: "#F5BBAD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.599 287.012H154.786V264.637H154.599V287.012Z",
    fill: "#F5BCAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.763 287.012H154.599V264.637H153.763V287.012Z",
    fill: "#F5BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.58 287.012H153.767V264.637H153.58V287.012Z",
    fill: "#F5BDB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.115 287.012H153.579V264.637H153.115V287.012Z",
    fill: "#F5BEB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.744 287.012H153.115V264.637H152.744V287.012Z",
    fill: "#F6BFB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.559 287.012H152.746V264.637H152.559V287.012Z",
    fill: "#F6BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.373 287.012H152.56V264.637H152.373V287.012Z",
    fill: "#F6BFB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.095 287.012H152.373V264.637H152.095V287.012Z",
    fill: "#F6C0B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.724 287.012H152.095V264.637H151.724V287.012Z",
    fill: "#F6C1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.074 287.012H151.723V264.637H151.074V287.012Z",
    fill: "#F6C1B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.794 287.012H151.072V264.637H150.794V287.012Z",
    fill: "#F6C2B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.61 287.012H150.797V264.637H150.61V287.012Z",
    fill: "#F6C2B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.332 287.012H150.61V264.637H150.332V287.012Z",
    fill: "#F6C3B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.961 287.012H150.332V264.637H149.961V287.012Z",
    fill: "#F7C4B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.59 287.012H149.961V264.637H149.59V287.012Z",
    fill: "#F7C4B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.31 287.012H149.587V264.637H149.31V287.012Z",
    fill: "#F7C5B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.939 287.012H149.31V264.637H148.939V287.012Z",
    fill: "#F7C6BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.567 287.012H148.938V264.637H148.567V287.012Z",
    fill: "#F7C6BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.918 287.012H148.567V264.637H147.918V287.012Z",
    fill: "#F7C7BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.547 287.012H147.918V264.637H147.547V287.012Z",
    fill: "#F7C8BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.899 287.012H147.547V264.637H146.899V287.012Z",
    fill: "#F7C9BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.528 287.012H146.899V264.637H146.528V287.012Z",
    fill: "#F7C9BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.246 287.012H146.524V264.637H146.246V287.012Z",
    fill: "#F7CAC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.875 287.012H146.247V264.637H145.875V287.012Z",
    fill: "#F7CBC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.504 287.012H145.875V264.637H145.504V287.012Z",
    fill: "#F7CCC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.321 287.012H145.508V264.637H145.321V287.012Z",
    fill: "#F7CCC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.133 287.012H145.321V264.637H145.133V287.012Z",
    fill: "#F7CCC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.762 287.012H145.133V264.637H144.762V287.012Z",
    fill: "#F7CDC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.485 287.012H144.762V264.637H144.485V287.012Z",
    fill: "#F7CDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.743 287.012H144.485V264.637H143.743V287.012Z",
    fill: "#F8CEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.465 287.012H143.743V264.637H143.465V287.012Z",
    fill: "#F8CFC6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.093 287.012H143.464V264.637H143.093V287.012Z",
    fill: "#F8D0C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.722 287.012H143.093V264.637H142.722V287.012Z",
    fill: "#F8D1C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.445 287.012H142.722V264.637H142.445V287.012Z",
    fill: "#F8D1C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.703 287.012H142.445V264.637H141.703V287.012Z",
    fill: "#F8D2C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.515 287.012H141.702V264.637H141.515V287.012Z",
    fill: "#F9D3CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.679 287.012H141.515V264.637H140.679V287.012Z",
    fill: "#F9D4CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.589 287.012H140.683V264.637H140.589V287.012Z",
    fill: "#F9D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.402 287.012H140.589V264.637H140.402V287.012Z",
    fill: "#F9D5CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.121 287.012H140.402V264.637H140.121V287.012Z",
    fill: "#F9D6CE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 262,
    width: 11,
    height: 18
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.175 279.569C155.677 273.31 157.901 266.065 157.901 266.065C157.901 266.065 155.838 264.636 154.221 264.636C154.083 264.636 153.95 264.646 153.821 264.669H153.818C154.363 263.631 154.599 262.762 154.68 262.08L161.348 262.225C160.457 265.295 158.298 271.228 157.226 273.494C157.223 273.5 157.22 273.507 157.216 273.513C157.213 273.516 157.21 273.523 157.207 273.529C156.655 274.644 154.46 276.78 151.817 279.026C151.604 279.207 151.391 279.388 151.175 279.569Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.28 279.569H161.373V262.08H161.28V279.569Z",
    fill: "#F4907D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.189 279.569H161.283V262.08H161.189V279.569Z",
    fill: "#F4917E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.003 279.569H161.19V262.08H161.003V279.569Z",
    fill: "#F4927E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.631 279.569H161.002V262.08H160.631V279.569Z",
    fill: "#F4927F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.26 279.569H160.631V262.08H160.26V279.569Z",
    fill: "#F49380"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.983 279.569H160.26V262.08H159.983V279.569Z",
    fill: "#F49481"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.611 279.569H159.982V262.08H159.611V279.569Z",
    fill: "#F49582"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.24 279.569H159.611V262.08H159.24V279.569Z",
    fill: "#F49683"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.959 279.569H159.237V262.08H158.959V279.569Z",
    fill: "#F49784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.588 279.569H158.959V262.08H158.588V279.569Z",
    fill: "#F49785"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.217 279.569H158.588V262.08H158.217V279.569Z",
    fill: "#F49886"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.94 279.569H158.217V262.08H157.94V279.569Z",
    fill: "#F49987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.569 279.569H157.94V262.08H157.569V279.569Z",
    fill: "#F49A88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.29 279.569H157.568V262.08H157.29V279.569Z",
    fill: "#F49B89"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.919 279.569H157.29V262.08H156.919V279.569Z",
    fill: "#F49B8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.548 279.569H156.919V262.08H156.548V279.569Z",
    fill: "#F49C8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.361 279.569H156.548V262.08H156.361V279.569Z",
    fill: "#F49D8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.177 279.569H156.365V262.08H156.177V279.569Z",
    fill: "#F49D8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.806 279.569H156.177V262.08H155.806V279.569Z",
    fill: "#F59E8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.619 279.569H155.806V262.08H155.619V279.569Z",
    fill: "#F59F8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.158 279.569H155.622V262.08H155.158V279.569Z",
    fill: "#F5A08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.787 279.569H155.158V262.08H154.787V279.569Z",
    fill: "#F5A08F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.599 279.569H154.786V262.08H154.599V279.569Z",
    fill: "#F5A190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.415 279.569H154.602V262.08H154.415V279.569Z",
    fill: "#F5A290"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.134 279.569H154.412V262.08H154.134V279.569Z",
    fill: "#F5A291"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.763 279.569H154.134V262.08H153.763V279.569Z",
    fill: "#F5A392"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.58 279.569H153.767V262.08H153.58V279.569Z",
    fill: "#F5A493"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.392 279.569H153.579V262.08H153.392V279.569Z",
    fill: "#F5A593"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.115 279.569H153.392V262.08H153.115V279.569Z",
    fill: "#F5A594"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.744 279.569H153.115V262.08H152.744V279.569Z",
    fill: "#F6A595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.559 279.569H152.746V262.08H152.559V279.569Z",
    fill: "#F6A696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.373 279.569H152.56V262.08H152.373V279.569Z",
    fill: "#F6A796"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.095 279.569H152.373V262.08H152.095V279.569Z",
    fill: "#F6A897"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.723 279.569H152.094V262.08H151.723V279.569Z",
    fill: "#F6A998"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.352 279.569H151.723V262.08H151.352V279.569Z",
    fill: "#F6AA99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.165 279.569H151.352V262.08H151.165V279.569Z",
    fill: "#F6AA9A"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.615 262.058L163.885 262.281C163.885 262.281 173.031 215.146 169.278 204.566C169.278 204.566 214.232 208.567 233.596 199.163C252.964 189.757 245.254 176.931 237.53 172.668C227.974 167.391 188.487 176.572 173.996 179.177C159.502 181.784 150.691 184.644 151.056 188.27C151.417 191.893 153.615 262.058 153.615 262.058Z",
    fill: "#473F65"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.885 262.282L161.348 262.227L154.68 262.081L153.615 262.059C153.615 262.059 151.417 191.893 151.056 188.271C151.046 188.2 151.043 188.129 151.043 188.058C151.04 185.553 155.458 183.414 163.12 181.469C162.988 181.902 162.913 182.357 162.894 182.839C162.894 182.907 162.891 182.978 162.891 183.049C162.881 187.085 166.922 195.212 172.747 204.823C170.546 204.68 169.278 204.567 169.278 204.567C169.917 206.364 170.181 209.217 170.181 212.717C170.185 219.429 169.213 228.513 168.032 237.073C166.208 250.306 163.885 262.282 163.885 262.282ZM237.592 172.702C237.311 172.64 237.027 172.579 236.743 172.521L237.185 172.488C237.305 172.546 237.421 172.608 237.53 172.669C237.55 172.679 237.572 172.692 237.592 172.702Z",
    fill: "#757390"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.459 279.453C217.459 279.453 218.446 302.661 220.857 303.049C225.65 303.828 229.958 278.723 230.575 271.843C230.83 268.973 225.424 259.944 221.109 261.156C215.987 262.597 217.459 279.453 217.459 279.453Z",
    fill: "#27356B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.303 259.631C214.303 259.631 216.581 260.678 216.83 265.502C217.078 270.327 218.495 291.603 219.883 291.82C221.267 292.03 226.215 272.608 225.402 269.009C224.588 265.412 220.948 254.658 220.435 254.848C219.922 255.039 214.303 259.631 214.303 259.631Z",
    fill: "#F4AF9F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.402 269.009C224.588 265.412 220.948 254.658 220.435 254.848C219.922 255.039 214.303 259.631 214.303 259.631C214.303 259.631 216.02 260.423 216.636 263.793C217.85 262.445 221.032 262.252 221.032 262.252C221.032 262.252 223.962 269.888 224.304 278.205C225.166 274.143 225.712 270.398 225.402 269.009Z",
    fill: "#F4907D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 216,
    y: 262,
    width: 10,
    height: 30
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.905 291.82C219.895 291.82 219.889 291.82 219.882 291.82C218.495 291.603 217.078 270.327 216.829 265.502C216.797 264.869 216.729 264.3 216.636 263.79C216.639 263.786 216.642 263.783 216.649 263.78L221.261 262.885C221.954 264.879 224.02 271.306 224.304 278.205C224.998 274.938 225.485 271.872 225.488 270.078C225.488 269.642 225.459 269.28 225.401 269.008C225.459 269.277 225.488 269.635 225.488 270.068C225.495 275.371 221.215 291.823 219.905 291.82Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.207 291.823H225.495V262.885H225.207V291.823Z",
    fill: "#F4AF9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.114 291.823H225.207V262.885H225.114V291.823Z",
    fill: "#F4B0A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.93 291.823H225.117V262.885H224.93V291.823Z",
    fill: "#F4B0A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.743 291.823H224.93V262.885H224.743V291.823Z",
    fill: "#F4B1A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.555 291.823H224.742V262.885H224.555V291.823Z",
    fill: "#F4B2A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.369 291.823H224.556V262.885H224.369V291.823Z",
    fill: "#F4B2A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.184 291.823H224.371V262.885H224.184V291.823Z",
    fill: "#F4B3A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.998 291.823H224.185V262.885H223.998V291.823Z",
    fill: "#F4B4A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.81 291.823H223.997V262.885H223.81V291.823Z",
    fill: "#F4B4A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.623 291.823H223.81V262.885H223.623V291.823Z",
    fill: "#F4B5A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.53 291.823H223.623V262.885H223.53V291.823Z",
    fill: "#F4B5A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.345 291.823H223.532V262.885H223.345V291.823Z",
    fill: "#F4B6A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.159 291.823H223.346V262.885H223.159V291.823Z",
    fill: "#F4B7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.971 291.823H223.158V262.885H222.971V291.823Z",
    fill: "#F4B7A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.784 291.823H222.971V262.885H222.784V291.823Z",
    fill: "#F4B7AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.69 291.823H222.784V262.885H222.69V291.823Z",
    fill: "#F4B8AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.6 291.823H222.694V262.885H222.6V291.823Z",
    fill: "#F4B9AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.413 291.823H222.6V262.885H222.413V291.823Z",
    fill: "#F5B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.039 291.823H222.413V262.885H222.039V291.823Z",
    fill: "#F5BAAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.851 291.823H222.038V262.885H221.851V291.823Z",
    fill: "#F5BBAD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.761 291.823H221.855V262.885H221.761V291.823Z",
    fill: "#F5BCAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.386 291.823H221.761V262.885H221.386V291.823Z",
    fill: "#F5BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.292 291.823H221.386V262.885H221.292V291.823Z",
    fill: "#F5BDB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.012 291.823H221.293V262.885H221.012V291.823Z",
    fill: "#F5BEB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.828 291.823H221.015V262.885H220.828V291.823Z",
    fill: "#F6BFB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.735 291.823H220.828V262.885H220.735V291.823Z",
    fill: "#F6BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.641 291.823H220.735V262.885H220.641V291.823Z",
    fill: "#F6BFB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.454 291.823H220.641V262.885H220.454V291.823Z",
    fill: "#F6C0B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.266 291.823H220.453V262.885H220.266V291.823Z",
    fill: "#F6C1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.895 291.823H220.27V262.885H219.895V291.823Z",
    fill: "#F6C1B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.802 291.823H219.896V262.885H219.802V291.823Z",
    fill: "#F6C2B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.708 291.823H219.802V262.885H219.708V291.823Z",
    fill: "#F6C2B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.521 291.823H219.708V262.885H219.521V291.823Z",
    fill: "#F6C3B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.337 291.823H219.525V262.885H219.337V291.823Z",
    fill: "#F7C4B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.15 291.823H219.337V262.885H219.15V291.823Z",
    fill: "#F7C4B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.056 291.823H219.15V262.885H219.056V291.823Z",
    fill: "#F7C5B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.869 291.823H219.056V262.885H218.869V291.823Z",
    fill: "#F7C6BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.682 291.823H218.869V262.885H218.682V291.823Z",
    fill: "#F7C6BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.31 291.823H218.685V262.885H218.31V291.823Z",
    fill: "#F7C7BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.124 291.823H218.311V262.885H218.124V291.823Z",
    fill: "#F7C8BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.749 291.823H218.123V262.885H217.749V291.823Z",
    fill: "#F7C9BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.659 291.823H217.752V262.885H217.659V291.823Z",
    fill: "#F7C9BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.471 291.823H217.658V262.885H217.471V291.823Z",
    fill: "#F7CAC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.285 291.823H217.472V262.885H217.285V291.823Z",
    fill: "#F7CBC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.097 291.823H217.284V262.885H217.097V291.823Z",
    fill: "#F7CCC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.914 291.823H217.101V262.885H216.914V291.823Z",
    fill: "#F7CCC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.726 291.823H216.913V262.885H216.726V291.823Z",
    fill: "#F7CDC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.632 291.823H216.726V262.885H216.632V291.823Z",
    fill: "#F7CDC4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 221,
    y: 262,
    width: 5,
    height: 17
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.304 278.206C224.02 271.307 221.955 264.879 221.261 262.886L223.462 262.459C224.307 265.015 225.076 267.578 225.401 269.009C225.46 269.281 225.489 269.643 225.489 270.079C225.485 271.872 224.998 274.939 224.304 278.206Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.395 278.206H225.489V262.459H225.395V278.206Z",
    fill: "#F4907C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.208 278.206H225.395V262.459H225.208V278.206Z",
    fill: "#F4907D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.114 278.206H225.207V262.459H225.114V278.206Z",
    fill: "#F4917E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.93 278.206H225.117V262.459H224.93V278.206Z",
    fill: "#F4927F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.743 278.206H224.93V262.459H224.743V278.206Z",
    fill: "#F49380"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.556 278.206H224.743V262.459H224.556V278.206Z",
    fill: "#F49481"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.369 278.206H224.556V262.459H224.369V278.206Z",
    fill: "#F49582"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.185 278.206H224.372V262.459H224.185V278.206Z",
    fill: "#F49683"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.998 278.206H224.185V262.459H223.998V278.206Z",
    fill: "#F49784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.81 278.206H223.997V262.459H223.81V278.206Z",
    fill: "#F49785"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.624 278.206H223.811V262.459H223.624V278.206Z",
    fill: "#F49886"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.53 278.206H223.623V262.459H223.53V278.206Z",
    fill: "#F49987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.345 278.206H223.532V262.459H223.345V278.206Z",
    fill: "#F49A88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.159 278.206H223.346V262.459H223.159V278.206Z",
    fill: "#F49B89"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.971 278.206H223.158V262.459H222.971V278.206Z",
    fill: "#F49B8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.784 278.206H222.971V262.459H222.784V278.206Z",
    fill: "#F49C8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.691 278.206H222.785V262.459H222.691V278.206Z",
    fill: "#F49D8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.6 278.206H222.694V262.459H222.6V278.206Z",
    fill: "#F49D8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.413 278.206H222.6V262.459H222.413V278.206Z",
    fill: "#F59E8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.319 278.206H222.412V262.459H222.319V278.206Z",
    fill: "#F59F8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.039 278.206H222.32V262.459H222.039V278.206Z",
    fill: "#F5A08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.854 278.206H222.041V262.459H221.854V278.206Z",
    fill: "#F5A08F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.761 278.206H221.855V262.459H221.761V278.206Z",
    fill: "#F5A190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.667 278.206H221.761V262.459H221.667V278.206Z",
    fill: "#F5A290"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.48 278.206H221.667V262.459H221.48V278.206Z",
    fill: "#F5A291"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.386 278.206H221.48V262.459H221.386V278.206Z",
    fill: "#F5A392"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.293 278.206H221.387V262.459H221.293V278.206Z",
    fill: "#F5A493"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.2 278.206H221.293V262.459H221.2V278.206Z",
    fill: "#F5A593"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.289 115.701L227.155 112.673C227.155 112.673 233.632 111.707 237.114 113.533C240.9 115.517 229.31 129.002 229.31 129.002C229.31 129.002 236.846 149.306 237.937 152.027C241.381 160.571 247.439 171.755 247.439 171.755L213.08 174.22C211.192 160.806 197.534 148.892 196.042 143.03C194.897 138.525 212.289 115.701 212.289 115.701Z",
    fill: "#FC686F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.254 113.008C227.122 112.782 222.236 109.357 220.906 104.881C220.228 102.609 220.493 99.9111 220.774 98.2404L220.848 98.1079C223.139 96.3273 225.724 92.6887 224.624 91.0083C223.585 89.4249 220.396 91.0438 219.505 91.5383C217.262 89.273 213.928 86.0447 211.895 84.7263C206.693 81.3558 199.992 79.3652 199.992 79.3652C199.992 79.3652 194.606 101.627 202.148 109.05C202.148 109.05 205.092 109.363 209.078 107.896C210.891 112.133 214.028 119.633 213.802 120.363C213.702 120.69 216.171 120.719 217.946 120.509C222.742 119.946 227.416 113.286 227.254 113.008Z",
    fill: "#F4AF9F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.224 120.58L217.947 120.509C222.743 119.946 227.416 113.286 227.255 113.008C227.122 112.782 222.236 109.357 220.906 104.881C220.229 102.609 220.493 99.9111 220.774 98.2404L220.848 98.1079C223.14 96.3273 225.725 92.6887 224.624 91.0083C223.585 89.4249 220.397 91.0438 219.506 91.5383C217.263 89.273 213.929 86.0447 211.896 84.7263C206.693 81.3558 199.993 79.3652 199.993 79.3652C199.993 79.3652 199.877 79.8306 199.709 80.6449C202.346 81.9084 213.874 87.6411 216.798 92.7695C220.016 98.4149 207.203 108.313 201.148 107.88C201.455 108.303 201.784 108.691 202.149 109.05C202.149 109.05 205.092 109.363 209.078 107.896C209.207 108.203 209.346 108.523 209.491 108.859C212.012 108.271 214.436 107.44 215.594 106.306C215.594 106.306 225.218 116.851 217.224 120.58Z",
    fill: "#F4907D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 209,
    y: 106,
    width: 12,
    height: 15
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.597 120.642C214.59 120.642 213.793 120.558 213.799 120.383C213.799 120.377 213.799 120.37 213.802 120.364C213.809 120.338 213.812 120.305 213.812 120.263C213.809 119.171 211.14 112.734 209.371 108.582C209.41 108.672 209.449 108.766 209.491 108.86C212.011 108.271 214.435 107.441 215.593 106.307C215.593 106.307 220.406 111.577 220.399 115.985C220.396 117.811 219.566 119.488 217.223 120.58C216.678 120.622 216.11 120.642 215.597 120.642Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.315 120.642H220.428V106.307H220.315V120.642Z",
    fill: "#F4B7AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.089 120.642H220.318V106.307H220.089V120.642Z",
    fill: "#F4B8AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.747 120.642H220.089V106.307H219.747V120.642Z",
    fill: "#F4B9AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.292 120.642H219.747V106.307H219.292V120.642Z",
    fill: "#F5B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.382 120.642H219.292V106.307H218.382V120.642Z",
    fill: "#F5BAAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.927 120.642H218.382V106.307H217.927V120.642Z",
    fill: "#F5BBAD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.697 120.642H217.927V106.307H217.697V120.642Z",
    fill: "#F5BCAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.562 120.642H217.701V106.307H216.562V120.642Z",
    fill: "#F5BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.332 120.642H216.561V106.307H216.332V120.642Z",
    fill: "#F5BDB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.651 120.642H216.336V106.307H215.651V120.642Z",
    fill: "#F5BEB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.197 120.642H215.652V106.307H215.197V120.642Z",
    fill: "#F6BFB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.968 120.642H215.197V106.307H214.968V120.642Z",
    fill: "#F6BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.741 120.642H214.97V106.307H214.741V120.642Z",
    fill: "#F6BFB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.287 120.642H214.742V106.307H214.287V120.642Z",
    fill: "#F6C0B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.831 120.642H214.287V106.307H213.831V120.642Z",
    fill: "#F6C1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.921 120.642H213.831V106.307H212.921V120.642Z",
    fill: "#F6C1B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.579 120.642H212.921V106.307H212.579V120.642Z",
    fill: "#F6C2B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.35 120.642H212.579V106.307H212.35V120.642Z",
    fill: "#F6C2B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.895 120.642H212.35V106.307H211.895V120.642Z",
    fill: "#F6C3B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.44 120.642H211.895V106.307H211.44V120.642Z",
    fill: "#F7C4B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.985 120.642H211.44V106.307H210.985V120.642Z",
    fill: "#F7C4B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.53 120.642H210.985V106.307H210.53V120.642Z",
    fill: "#F7C5B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.075 120.642H210.53V106.307H210.075V120.642Z",
    fill: "#F7C6BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.62 120.642H210.075V106.307H209.62V120.642Z",
    fill: "#F7C6BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.278 120.642H209.62V106.307H209.278V120.642Z",
    fill: "#F7C7BC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 120,
    width: 1,
    height: 1
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.23 120.577L217.947 120.51C217.717 120.539 217.475 120.561 217.23 120.577Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.927 120.577H218.04V120.51H217.927V120.577Z",
    fill: "#F5BBAD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.698 120.577H217.927V120.51H217.698V120.577Z",
    fill: "#F5BCAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.13 120.577H217.698V120.51H217.13V120.577Z",
    fill: "#F5BCAF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 108,
    width: 2,
    height: 2
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.148 109.049C202.093 108.994 202.038 108.94 201.984 108.881C202.038 108.94 202.093 108.994 202.148 109.049Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.883 109.049H202.225V108.881H201.883V109.049Z",
    fill: "#F8D1C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 108,
    width: 1,
    height: 1
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.981 108.878C201.971 108.869 201.961 108.859 201.952 108.849C201.961 108.859 201.971 108.869 201.981 108.878Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.884 108.878H201.997V108.849H201.884V108.878Z",
    fill: "#F8D1C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 108,
    width: 1,
    height: 1
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.939 108.834C201.936 108.831 201.932 108.831 201.929 108.827C201.932 108.827 201.936 108.831 201.939 108.834Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.884 108.834H201.997V108.827H201.884V108.834Z",
    fill: "#F8D1C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 80,
    width: 20,
    height: 28
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.542 107.892C201.406 107.892 201.277 107.889 201.148 107.88C198.84 104.69 198.127 99.7685 198.127 94.9083C198.13 88.9882 199.189 83.1554 199.708 80.6445C202.348 81.9113 213.873 87.6439 216.797 92.7691C217.146 93.3863 217.307 94.052 217.307 94.7468C217.301 100.311 207.051 107.892 201.542 107.892Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.562 107.892H217.359V80.6445H216.562V107.892Z",
    fill: "#F5BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.333 107.892H216.562V80.6445H216.333V107.892Z",
    fill: "#F5BDB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.651 107.892H216.336V80.6445H215.651V107.892Z",
    fill: "#F5BEB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.197 107.892H215.652V80.6445H215.197V107.892Z",
    fill: "#F6BFB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.968 107.892H215.197V80.6445H214.968V107.892Z",
    fill: "#F6BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.741 107.892H214.97V80.6445H214.741V107.892Z",
    fill: "#F6BFB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.287 107.892H214.742V80.6445H214.287V107.892Z",
    fill: "#F6C0B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.831 107.892H214.287V80.6445H213.831V107.892Z",
    fill: "#F6C1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.921 107.892H213.831V80.6445H212.921V107.892Z",
    fill: "#F6C1B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.579 107.892H212.921V80.6445H212.579V107.892Z",
    fill: "#F6C2B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.35 107.892H212.579V80.6445H212.35V107.892Z",
    fill: "#F6C2B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.895 107.892H212.35V80.6445H211.895V107.892Z",
    fill: "#F6C3B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.44 107.892H211.895V80.6445H211.44V107.892Z",
    fill: "#F7C4B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.985 107.892H211.44V80.6445H210.985V107.892Z",
    fill: "#F7C4B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.53 107.892H210.985V80.6445H210.53V107.892Z",
    fill: "#F7C5B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.075 107.892H210.53V80.6445H210.075V107.892Z",
    fill: "#F7C6BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.62 107.892H210.075V80.6445H209.62V107.892Z",
    fill: "#F7C6BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.709 107.892H209.62V80.6445H208.709V107.892Z",
    fill: "#F7C7BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.254 107.892H208.709V80.6445H208.254V107.892Z",
    fill: "#F7C8BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.344 107.892H208.254V80.6445H207.344V107.892Z",
    fill: "#F7C9BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.889 107.892H207.344V80.6445H206.889V107.892Z",
    fill: "#F7C9BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.434 107.892H206.889V80.6445H206.434V107.892Z",
    fill: "#F7CAC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.979 107.892H206.434V80.6445H205.979V107.892Z",
    fill: "#F7CBC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.524 107.892H205.979V80.6445H205.524V107.892Z",
    fill: "#F7CCC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.182 107.892H205.524V80.6445H205.182V107.892Z",
    fill: "#F7CCC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.956 107.892H205.185V80.6445H204.956V107.892Z",
    fill: "#F7CCC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.501 107.892H204.956V80.6445H204.501V107.892Z",
    fill: "#F7CDC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.046 107.892H204.501V80.6445H204.046V107.892Z",
    fill: "#F7CDC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.136 107.892H204.046V80.6445H203.136V107.892Z",
    fill: "#F8CEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.681 107.892H203.136V80.6445H202.681V107.892Z",
    fill: "#F8CFC6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.226 107.892H202.681V80.6445H202.226V107.892Z",
    fill: "#F8D0C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.771 107.892H202.226V80.6445H201.771V107.892Z",
    fill: "#F8D1C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.316 107.892H201.771V80.6445H201.316V107.892Z",
    fill: "#F8D1C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.402 107.892H201.312V80.6445H200.402V107.892Z",
    fill: "#F8D2C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.176 107.892H200.405V80.6445H200.176V107.892Z",
    fill: "#F9D3CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.037 107.892H200.176V80.6445H199.037V107.892Z",
    fill: "#F9D4CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.812 107.892H199.041V80.6445H198.812V107.892Z",
    fill: "#F9D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.582 107.892H198.811V80.6445H198.582V107.892Z",
    fill: "#F9D5CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.127 107.892H198.582V80.6445H198.127V107.892Z",
    fill: "#F9D6CE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 79,
    width: 29,
    height: 42
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.224 120.58C219.567 119.487 220.397 117.81 220.4 115.984C220.406 111.577 215.594 106.306 215.594 106.306C214.436 107.44 212.012 108.271 209.491 108.859C209.449 108.765 209.411 108.672 209.372 108.581C209.269 108.345 209.172 108.116 209.078 107.896C206.28 108.924 203.998 109.079 202.885 109.079C202.62 109.079 202.42 109.069 202.294 109.063C202.201 109.056 202.149 109.05 202.149 109.05C202.094 108.995 202.039 108.94 201.984 108.882C201.981 108.882 201.981 108.878 201.981 108.878C201.971 108.869 201.962 108.859 201.952 108.849C201.949 108.843 201.942 108.84 201.939 108.833C201.936 108.83 201.933 108.827 201.929 108.827C201.649 108.529 201.39 108.216 201.148 107.88C201.277 107.89 201.407 107.893 201.542 107.893C207.051 107.893 217.301 100.312 217.308 94.7471C217.308 94.0524 217.147 93.3867 216.798 92.7695C213.874 87.6443 202.349 81.9116 199.709 80.6449C199.874 79.8597 199.983 79.3975 199.99 79.3652C199.993 79.3652 199.993 79.3652 199.993 79.3652C199.993 79.3652 206.693 81.3558 211.896 84.7263C213.929 86.0447 217.263 89.273 219.506 91.5383C220.116 91.199 221.81 90.3297 223.149 90.3297C223.759 90.3297 224.298 90.5106 224.624 91.0083C224.805 91.283 224.886 91.6126 224.886 91.9777C224.886 93.8326 222.765 96.6182 220.848 98.1079L220.774 98.2404C220.626 99.129 220.48 100.305 220.48 101.556C220.477 102.658 220.59 103.818 220.906 104.881C222.236 109.357 227.122 112.782 227.255 113.008C227.258 113.012 227.258 113.018 227.258 113.028C227.251 113.519 222.659 119.956 217.947 120.509L217.23 120.576L217.224 120.58Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.145 120.58H227.258V79.3652H227.145V120.58Z",
    fill: "#F4907C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.69 120.58H227.145V79.3652H226.69V120.58Z",
    fill: "#F4907D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.461 120.58H226.69V79.3652H226.461V120.58Z",
    fill: "#F4917E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.234 120.58H226.464V79.3652H226.234V120.58Z",
    fill: "#F4927E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.78 120.58H226.235V79.3652H225.78V120.58Z",
    fill: "#F4927F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.325 120.58H225.78V79.3652H225.325V120.58Z",
    fill: "#F49380"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.87 120.58H225.325V79.3652H224.87V120.58Z",
    fill: "#F49481"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.414 120.58H224.87V79.3652H224.414V120.58Z",
    fill: "#F49582"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.959 120.58H224.414V79.3652H223.959V120.58Z",
    fill: "#F49683"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.504 120.58H223.959V79.3652H223.504V120.58Z",
    fill: "#F49784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.049 120.58H223.504V79.3652H223.049V120.58Z",
    fill: "#F49785"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.591 120.58H223.046V79.3652H222.591V120.58Z",
    fill: "#F49886"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.136 120.58H222.591V79.3652H222.136V120.58Z",
    fill: "#F49987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.681 120.58H222.136V79.3652H221.681V120.58Z",
    fill: "#F49A88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.226 120.58H221.681V79.3652H221.226V120.58Z",
    fill: "#F49B89"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.771 120.58H221.226V79.3652H220.771V120.58Z",
    fill: "#F49B8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.316 120.58H220.771V79.3652H220.316V120.58Z",
    fill: "#F49C8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.09 120.58H220.319V79.3652H220.09V120.58Z",
    fill: "#F49D8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.747 120.58H220.089V79.3652H219.747V120.58Z",
    fill: "#F49D8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.292 120.58H219.747V79.3652H219.292V120.58Z",
    fill: "#F59E8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.067 120.58H219.296V79.3652H219.067V120.58Z",
    fill: "#F59F8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.383 120.58H219.067V79.3652H218.383V120.58Z",
    fill: "#F5A08E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.927 120.58H218.382V79.3652H217.927V120.58Z",
    fill: "#F5A08F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.698 120.58H217.927V79.3652H217.698V120.58Z",
    fill: "#F5A190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.473 120.58H217.702V79.3652H217.473V120.58Z",
    fill: "#F5A290"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.017 120.58H217.472V79.3652H217.017V120.58Z",
    fill: "#F5A291"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.562 120.58H217.017V79.3652H216.562V120.58Z",
    fill: "#F5A392"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.333 120.58H216.562V79.3652H216.333V120.58Z",
    fill: "#F5A493"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.108 120.58H216.337V79.3652H216.108V120.58Z",
    fill: "#F5A593"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.652 120.58H216.107V79.3652H215.652V120.58Z",
    fill: "#F5A594"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.198 120.58H215.653V79.3652H215.198V120.58Z",
    fill: "#F6A595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.968 120.58H215.197V79.3652H214.968V120.58Z",
    fill: "#F6A696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.742 120.58H214.971V79.3652H214.742V120.58Z",
    fill: "#F6A796"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.288 120.58H214.743V79.3652H214.288V120.58Z",
    fill: "#F6A897"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.832 120.58H214.288V79.3652H213.832V120.58Z",
    fill: "#F6A998"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.377 120.58H213.832V79.3652H213.377V120.58Z",
    fill: "#F6AA99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.922 120.58H213.377V79.3652H212.922V120.58Z",
    fill: "#F6AA9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.35 120.58H212.918V79.3652H212.35V120.58Z",
    fill: "#F6AB9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.896 120.58H212.351V79.3652H211.896V120.58Z",
    fill: "#F6AC9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.441 120.58H211.896V79.3652H211.441V120.58Z",
    fill: "#F7AD9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.215 120.58H211.444V79.3652H211.215V120.58Z",
    fill: "#F7AE9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.985 120.58H211.215V79.3652H210.985V120.58Z",
    fill: "#F7AE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.531 120.58H210.986V79.3652H210.531V120.58Z",
    fill: "#F7AF9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.076 120.58H210.531V79.3652H210.076V120.58Z",
    fill: "#F7AFA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.621 120.58H210.076V79.3652H209.621V120.58Z",
    fill: "#F7B0A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.165 120.58H209.621V79.3652H209.165V120.58Z",
    fill: "#F7B1A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.71 120.58H209.165V79.3652H208.71V120.58Z",
    fill: "#F7B2A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.255 120.58H208.71V79.3652H208.255V120.58Z",
    fill: "#F7B3A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.8 120.58H208.255V79.3652H207.8V120.58Z",
    fill: "#F7B4A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.574 120.58H207.803V79.3652H207.574V120.58Z",
    fill: "#F7B5A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.345 120.58H207.574V79.3652H207.345V120.58Z",
    fill: "#F7B5A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.89 120.58H207.345V79.3652H206.89V120.58Z",
    fill: "#F7B5A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.435 120.58H206.89V79.3652H206.435V120.58Z",
    fill: "#F7B6A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.209 120.58H206.438V79.3652H206.209V120.58Z",
    fill: "#F7B7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.98 120.58H206.209V79.3652H205.98V120.58Z",
    fill: "#F7B7A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.525 120.58H205.98V79.3652H205.525V120.58Z",
    fill: "#F7B8A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.183 120.58H205.525V79.3652H205.183V120.58Z",
    fill: "#F7B9AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.957 120.58H205.186V79.3652H204.957V120.58Z",
    fill: "#F7B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.046 120.58H204.956V79.3652H204.046V120.58Z",
    fill: "#F7BAAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.817 120.58H204.047V79.3652H203.817V120.58Z",
    fill: "#F8BBAD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.592 120.58H203.821V79.3652H203.592V120.58Z",
    fill: "#F8BCAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.136 120.58H203.591V79.3652H203.136V120.58Z",
    fill: "#F8BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.681 120.58H203.136V79.3652H202.681V120.58Z",
    fill: "#F8BDAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.452 120.58H202.681V79.3652H202.452V120.58Z",
    fill: "#F8BEB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.227 120.58H202.456V79.3652H202.227V120.58Z",
    fill: "#F8BEB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.771 120.58H202.226V79.3652H201.771V120.58Z",
    fill: "#F8BFB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.316 120.58H201.771V79.3652H201.316V120.58Z",
    fill: "#F8BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.087 120.58H201.316V79.3652H201.087V120.58Z",
    fill: "#F8C0B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.861 120.58H201.091V79.3652H200.861V120.58Z",
    fill: "#F8C1B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.403 120.58H200.858V79.3652H200.403V120.58Z",
    fill: "#F8C2B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.948 120.58H200.403V79.3652H199.948V120.58Z",
    fill: "#F9C2B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.609 120.58H199.951V79.3652H199.609V120.58Z",
    fill: "#F9C3B6"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.926 141.393C231.66 135.331 229.311 129.001 229.311 129.001C229.311 129.001 230.418 127.714 231.831 125.879C232.16 126.221 232.38 126.474 232.406 126.554C232.454 126.693 233.112 133.269 233.926 141.393Z",
    fill: "#312B4B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.84 172.342C235.494 172.342 229.869 171.159 229.869 171.159C223.824 147.977 228.297 122.803 228.297 122.441C228.297 122.441 230.702 124.697 231.831 125.88C230.418 127.715 229.311 129.001 229.311 129.001C229.311 129.001 231.66 135.332 233.926 141.394C235.246 154.621 236.972 171.948 237.121 172.248C237.153 172.313 237.05 172.342 236.84 172.342Z",
    fill: "#CE484E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.577 264.181L225.818 262C225.818 262 214.758 227.869 195.9 207.533C195.9 207.533 218.434 217.754 239.786 211.346C261.132 204.935 259.338 182.44 246.493 175.758C231.292 167.853 198.857 171.492 183.749 173.58C169.729 175.519 163.1 177.638 162.894 182.838C162.348 196.821 214.577 264.181 214.577 264.181Z",
    fill: "#473F65"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 170,
    width: 95,
    height: 95
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.577 264.181C214.577 264.181 162.858 197.476 162.891 183.048C162.891 182.976 162.894 182.905 162.894 182.838C163.1 177.638 169.729 175.518 183.749 173.579C191.834 172.464 204.876 170.9 217.585 170.9C228.629 170.9 239.425 172.08 246.493 175.757C252.451 178.856 256.033 185.358 256.027 192.08C256.023 199.848 251.231 207.907 239.786 211.346C234.69 212.874 229.526 213.456 224.618 213.456C209.016 213.456 195.987 207.571 195.9 207.533C195.946 207.552 199.438 209.126 204.934 210.645C197.601 204.876 188.038 201.118 188.038 201.118L195.626 207.303L195.9 207.533C214.758 227.868 225.818 261.999 225.818 261.999L223.462 262.458L221.261 262.885L216.649 263.78L216.633 263.783L214.577 264.181Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.21 264.181H256.033V170.9H254.21V264.181Z",
    fill: "#74728F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.846 264.181H254.212V170.9H249.846V264.181Z",
    fill: "#757390"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.391 264.181H249.846V170.9H248.391V264.181Z",
    fill: "#767490"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.479 264.181H248.391V170.9H245.479V264.181Z",
    fill: "#767491"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.568 264.181H245.479V170.9H242.568V264.181Z",
    fill: "#777591"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.657 264.181H242.568V170.9H239.657V264.181Z",
    fill: "#777592"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.746 264.181H239.657V170.9H236.746V264.181Z",
    fill: "#787692"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.294 264.181H236.75V170.9H235.294V264.181Z",
    fill: "#787693"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.562 264.181H235.291V170.9H230.562V264.181Z",
    fill: "#797793"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.196 264.181H230.563V170.9H226.196V264.181Z",
    fill: "#7A7894"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.74 264.181H226.196V170.9H224.74V264.181Z",
    fill: "#7A7895"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.377 264.181H224.744V170.9H220.377V264.181Z",
    fill: "#7B7995"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.921 264.181H220.377V170.9H218.921V264.181Z",
    fill: "#7C7A95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.555 264.181H218.921V170.9H214.555V264.181Z",
    fill: "#7C7A96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.188 264.181H214.554V170.9H210.188V264.181Z",
    fill: "#7D7B97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.371 264.181H210.191V170.9H208.371V264.181Z",
    fill: "#7E7C97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.46 264.181H208.371V170.9H205.46V264.181Z",
    fill: "#7E7C98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.549 264.181H205.46V170.9H202.549V264.181Z",
    fill: "#7F7D98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.093 264.181H202.549V170.9H201.093V264.181Z",
    fill: "#7F7D99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.727 264.181H201.093V170.9H196.727V264.181Z",
    fill: "#807E99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.271 264.181H196.726V170.9H195.271V264.181Z",
    fill: "#807E9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.907 264.181H195.274V170.9H190.907V264.181Z",
    fill: "#817F9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.541 264.181H190.908V170.9H186.541V264.181Z",
    fill: "#82809B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.357 264.181H186.541V170.9H180.357V264.181Z",
    fill: "#83819C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.902 264.181H180.357V170.9H178.902V264.181Z",
    fill: "#84829C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.99 264.181H178.901V170.9H175.99V264.181Z",
    fill: "#84829D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.079 264.181H175.99V170.9H173.079V264.181Z",
    fill: "#85839D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.168 264.181H173.079V170.9H170.168V264.181Z",
    fill: "#85839E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.713 264.181H170.169V170.9H168.713V264.181Z",
    fill: "#86849E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.805 264.181H168.716V170.9H165.805V264.181Z",
    fill: "#86849F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.858 264.181H165.805V170.9H162.858V264.181Z",
    fill: "#87859F"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.368 207.737L253.893 212.06V222.349L245.05 222.963L242.997 213.292L238.889 212.884L237.653 219.263L234.98 208.767H242.381L241.968 205.475L249.368 207.737Z",
    fill: "#F4907D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.602 115.296C252.111 129.46 242.484 147.495 246.673 162.625C247.767 166.577 249.817 206.925 249.817 206.925L240.148 206.806C240.148 206.806 236.985 190.396 234.583 178.605C232.347 167.608 228.268 150.516 228.329 137.477L228.048 120.848C227.809 120.79 229.471 114.446 232.437 113.48C236.065 112.301 238.343 113.875 239.602 115.296Z",
    fill: "#FC686F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_7139_104939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 201,
    width: 17,
    height: 10
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.933 210.646C199.437 209.127 195.945 207.553 195.9 207.534L195.626 207.304L188.038 201.119C188.038 201.119 197.601 204.877 204.933 210.646Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_7139_104939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.548 210.646H205.095V201.119H202.548V210.646Z",
    fill: "#59576A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.093 210.646H202.549V201.119H201.093V210.646Z",
    fill: "#59576B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.727 210.646H201.093V201.119H196.727V210.646Z",
    fill: "#5A586B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.271 210.646H196.726V201.119H195.271V210.646Z",
    fill: "#5A586C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.907 210.646H195.274V201.119H190.907V210.646Z",
    fill: "#5A596C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.996 210.646H190.907V201.119H187.996V210.646Z",
    fill: "#5B5A6D"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.463 80.5807H96.2579C82.8062 80.5807 71.8008 69.5613 71.8008 56.0924C71.8008 42.6268 82.8062 31.6074 96.2579 31.6074H132.463C145.914 31.6074 156.917 42.6268 156.917 56.0924C156.917 69.5613 145.914 80.5807 132.463 80.5807Z",
    fill: "#473F65"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.181 54.0703L143.197 91.6526L125.056 72.199C125.056 72.199 143.745 54.0703 143.181 54.0703Z",
    fill: "#473F65"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.025 47.6289L122.878 63.8057H104.762L100.393 48.9409L127.025 47.6289Z",
    fill: "#F5F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.307 67.7328C117.307 69.1224 118.436 70.2437 119.824 70.2437C121.205 70.2437 122.332 69.1224 122.332 67.7328C122.332 66.3433 121.205 65.2188 119.824 65.2188C118.436 65.2188 117.307 66.3433 117.307 67.7328Z",
    fill: "#F5F5F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.143 67.7328C105.143 69.1224 106.266 70.2437 107.65 70.2437C109.038 70.2437 110.164 69.1224 110.164 67.7328C110.164 66.3433 109.038 65.2188 107.65 65.2188C106.266 65.2188 105.143 66.3433 105.143 67.7328Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.353 48.2913L126.982 47.8292L128.419 43.2631H131.101C131.465 43.2631 131.762 42.969 131.762 42.6039C131.762 42.2355 131.465 41.9414 131.101 41.9414H127.934L127.302 42.4003L125.72 47.4317C125.611 47.7775 125.801 48.1523 126.153 48.2622L126.353 48.2913Z",
    fill: "#F5F5F5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.292 66.3916H122.29C122.645 66.3916 122.933 66.104 122.933 65.7518C122.933 65.3931 122.645 65.1055 122.29 65.1055H105.292C104.933 65.1055 104.649 65.3931 104.649 65.7518C104.649 66.104 104.933 66.3916 105.292 66.3916Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWoman);
export default __webpack_public_path__ + "static/media/cart_woman.d6bbe585877a869843abd0307a51c5dc.svg";
export { ForwardRef as ReactComponent };